import React, { useState } from 'react';
import townsData from '../../data/towns_data';
import './towns.css';

const Towns = () => {

  const handleTownClick = (townName) => {
    window.location.href = `/${townName}`;
  }

  return (
    <div >
      <div className="grid-container">
        {townsData.map((town) => (
          <div 
            key={town.name} 
            className="town-container" 
            onClick={() => handleTownClick(town.name)}
          >
            <h2 className='town-name'>{town.name}</h2>
            <img className="town-image" src={town.image} alt={town.name} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Towns;
